import styled from 'styled-components'

import FormSubmitButton from '../../form/FormSubmitButton'
import FormikForm from '../../form/FormikForm'
import { mq, sizes } from '../../theme'
import {
  Label as OptionLabel,
  OptionRadio,
} from '../../form/fields/FormFieldRadioGroup/styled'
import { Label } from '../../form/fields/FormFieldSelect/styled'
import FormFieldSelect from '../../form/fields/FormFieldSelect'

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Form = styled(FormikForm)`
  width: 100%;

  ${OptionRadio} {
    background-color: ${({ theme }) => theme.colors.blueBack};
  }

  ${OptionLabel} {
    margin-bottom: 1.5rem;
  }

  ${Label} {
    margin-bottom: 1.5rem;
  }
`

export const Select = styled(FormFieldSelect)`
  max-width: max(25.6rem, 50%);
`

export const Fields = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 1.5rem;

  @media ${mq(sizes.tablet)} {
    gap: 3rem;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 3rem auto 0 auto;
`

export const SubmitButton = styled(FormSubmitButton)``
